// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const TEAM = [
  { name:"Jordan Lutz",i:"JL",tasks:8,completed:5,inProgress:2,todo:1 },
  { name:"Ryan Miskulin",i:"RM",tasks:5,completed:3,inProgress:1,todo:1 },
  { name:"Taylor Schenher",i:"TS",tasks:6,completed:4,inProgress:1,todo:1 },
  { name:"Des Bachynski",i:"DB",tasks:4,completed:2,inProgress:1,todo:1 },
  { name:"Lucas Mason",i:"LM",tasks:7,completed:4,inProgress:2,todo:1 },
  { name:"Lee Mehling",i:"LMe",tasks:5,completed:3,inProgress:1,todo:1 },
  { name:"Clorice Robertson",i:"CR",tasks:4,completed:3,inProgress:1,todo:0 },
  { name:"Tyson Becker",i:"TB",tasks:6,completed:3,inProgress:2,todo:1 },
  { name:"Tyler Hodgson",i:"TH",tasks:5,completed:2,inProgress:2,todo:1 },
];

const ALL_TASKS = [
  { id:1,title:"Implement notifications",assignee:"Jordan Lutz",priority:"P0",status:"In Progress",project:"Platform" },
  { id:2,title:"Q1 Revenue Forecast",assignee:"Taylor Schenher",priority:"P0",status:"Review",project:"Finance" },
  { id:3,title:"Partnership agreement",assignee:"Tyson Becker",priority:"P1",status:"In Progress",project:"Partnerships" },
  { id:4,title:"Sales deck refresh",assignee:"Lucas Mason",priority:"P1",status:"To Do",project:"Sales" },
  { id:5,title:"Mining compliance audit",assignee:"Lee Mehling",priority:"P1",status:"To Do",project:"Mining" },
  { id:6,title:"Health platform beta",assignee:"Des Bachynski",priority:"P1",status:"In Progress",project:"Health" },
  { id:7,title:"AR reconciliation",assignee:"Clorice Robertson",priority:"P2",status:"Done",project:"Finance" },
  { id:8,title:"Overwatch enhancements",assignee:"Tyler Hodgson",priority:"P2",status:"In Progress",project:"Platform" },
  { id:9,title:"Board presentation",assignee:"Ryan Miskulin",priority:"P0",status:"Review",project:"Executive" },
  { id:10,title:"Security pen testing",assignee:"Tyler Hodgson",priority:"P0",status:"To Do",project:"Security" },
  { id:11,title:"Client onboarding docs",assignee:"Lucas Mason",priority:"P2",status:"Backlog",project:"Sales" },
  { id:12,title:"DB optimization",assignee:"Jordan Lutz",priority:"P1",status:"Backlog",project:"Platform" },
  { id:13,title:"Insurance broker campaign",assignee:"Lucas Mason",priority:"P2",status:"In Progress",project:"Insurance" },
  { id:14,title:"Benefits renewal",assignee:"Clorice Robertson",priority:"P2",status:"To Do",project:"HR" },
  { id:15,title:"Market report Q1",assignee:"Tyson Becker",priority:"P2",status:"To Do",project:"Commodities" },
];

export default function TeamTasksPage() {
  const [groupBy, setGroupBy] = useState("person");
  const [searchTerm, setSearchTerm] = useState("");
  const filtered = ALL_TASKS.filter(t => !searchTerm || t.title.toLowerCase().includes(searchTerm.toLowerCase()) || t.assignee.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div>
      <div className="page-header"><div><h1>Team Tasks</h1><p>All tasks across the team</p></div></div>
    </div>
  );
}